import { Box } from "@mui/material";
import React from "react";

function WelcomeAndAi() {
  return (
    <Box sx={{}}>
      <iframe
        src="https://bot.andaihub.com/ai-report"
        style={{ width: "100%", height:600, border: "none" }}
        title="AI Report"
      />
    </Box>
  );
}

export default WelcomeAndAi;
